<template>
  <div>
    <div v-if="isVisible" class="d-flex align-items-left">
    
    <b-spinner type="grow" class="spinner-loader"></b-spinner>
    <strong>{{message}}</strong>
  </div>            
    
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: 'Loader',
  props:{
    lang: Object
  },
  components: {


  },
  data () {
      return {
        

      }
  },
  computed: {
    isVisible(){

      return this.$store.getters.loader.visible;


    },
    
    message(){
      
      if (this.$store.getters.loader.text == "download"){
        return this.lang.alert_download;
      }
      if (this.$store.getters.loader.text == "load"){
        return this.lang.alert_load;
      }
      if (this.$store.getters.loader.text == "wait"){
        return this.lang.alert_wait;
      }
      if (this.$store.getters.loader.text == "open"){
        return this.lang.alert_open;
      }
      if (this.$store.getters.loader.text == "push"){
        return this.lang.alert_push;
      }
      return this.$store.getters.loader.text;
      

    },

  },
  created () {
    document.body.style.cursor = 'default';

  },
  watch: {
    text: function (newVal, oldVal) { 
      

    },
    isVisible: function(newVal, oldVal){

      
      if (newVal == true){
        
        document.body.style.cursor = 'wait';
      }
      if (newVal == false){
        
        document.body.style.cursor = 'default';
      }
    }
  },
  updated() {



  },
  mounted: function () {

  },
  methods: {



  }
}
</script>


<style scoped>
    .spinner-loader{
        width: 20px; 
        height: 20px;
        margin-right: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Footer/Loader.vue